/* challans - This line cannot be edited or removed */
export const GET_CHALLANS = "GET_CHALLANS"
export const GET_CHALLANS_SUCCESS = "GET_CHALLANS_SUCCESS"
export const GET_CHALLANS_FAIL = "GET_CHALLANS_FAIL"

/* Challan_DETAILS */
export const GET_CHALLAN_DETAILS = "GET_CHALLAN_DETAILS"
export const GET_CHALLAN_DETAILS_SUCCESS = "GET_CHALLAN_DETAILS_SUCCESS"
export const GET_CHALLAN_DETAILS_FAIL = "GET_CHALLAN_DETAILS_FAIL"

/* CREATE Challan */
export const CREATE_CHALLAN = "CREATE_CHALLAN"
export const CREATE_CHALLAN_SUCCESS = "CREATE_CHALLAN_SUCCESS"
export const CREATE_CHALLAN_FAIL = "CREATE_CHALLAN_FAIL"

/* Edit Challan */
export const UPDATE_CHALLAN = "UPDATE_CHALLAN"
export const UPDATE_CHALLAN_SUCCESS = "UPDATE_CHALLAN_SUCCESS"
export const UPDATE_CHALLAN_FAIL = "UPDATE_CHALLAN_FAIL"

/* Delete Challan */
export const CHECK_CHALLAN_NUMBER = "CHECK_CHALLAN_NUMBER"
export const CHECK_CHALLAN_NUMBER_SUCCESS = "CHECK_CHALLAN_NUMBER_SUCCESS"
export const CHECK_CHALLAN_NUMBER_FAIL = "CHECK_CHALLAN_NUMBER_FAIL"

export const RESET_CHALLAN_STATE = "RESET_CHALLAN_STATE"
